import React, { useState } from "react";
import { Flipper, Flipped } from "react-flip-toolkit";
import { BiChevronRight } from "react-icons/bi";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

import switch1 from "../../sounds/switch1.mp3";
import switch2 from "../../sounds/switch2.mp3";
import switch3 from "../../sounds/switch3.mp3";
import success from "../../sounds/success.wav";

// Quatsch
import JSConfetti from "js-confetti";
import useSound from "use-sound";

import Task from "../Task";
import InputField from "../InputField";

function TasksList({ sound }) {
  const [task, setTask] = React.useState("");
  const [tasks, setTasks] = React.useState([]);

  const [doneTasks, setDoneTasks] = useState([]);

  const [archiveIsVisible, setArchiveIsVisible] = React.useState(false);

  const volume = 0.2;
  const [allDoneSound] = useSound(success, { volume: volume });
  const [soundOne] = useSound(switch1, { volume: volume });
  const [soundTwo] = useSound(switch2, { volume: volume });
  const [soundThree] = useSound(switch3, { volume: volume });

  const sounds = [soundOne, soundTwo, soundThree];

  React.useEffect(() => {
    loadAll();
  }, []);

  // Sort by date added and then by done or undone
  // const sortedTasks = tasks.filter((task) => task.checked === false);
  // .sort((a, b) => b.date - a.date)
  // .sort((a, b) => a.checked - b.checked);

  // const doneTasks = tasks
  //   .filter((task) => task.checked === true)
  //   .sort((a, b) => b.checkedDate - a.checkedDate);

  // React.useEffect(() => {
  //   if (sortedTasks.length > 0) {
  //     document.title = `(${sortedTasks.length}) — Your Plate`;
  //   } else {
  //     document.title = "Your Plate";
  //   }
  // }, [sortedTasks]);

  function handleAddTask(event) {
    event.preventDefault();

    if (
      !task ||
      task.length === 0 ||
      task === "" ||
      !task.replace(/\s/g, "").length
    ) {
      return;
    }

    const nextTasks = [
      {
        id: crypto.randomUUID(),
        label: task,
        checked: false,
        date: Date.now(),
      },
      ...tasks,
    ];

    setTask("");
    setTasks(nextTasks);
    saveTasks(nextTasks);
  }

  function checkTask(incomingTask) {
    if (incomingTask.checked === false) {
      // Remove task from outstanding tasks
      const nextTasks = Array.from(tasks);
      const index = nextTasks.findIndex((i) => i.id === incomingTask.id);
      const removedTask = nextTasks.splice(index, 1).shift();

      setTasks(nextTasks);
      saveTasks(nextTasks);

      // Add task to doneTasks list.
      const taskChecked = {
        ...removedTask,
        checked: true,
      };
      const nextDoneTasks = [...doneTasks, taskChecked];
      setDoneTasks(nextDoneTasks);
      saveDoneTasks(nextDoneTasks);

      checkIfConfetti(nextTasks);
    } else if (incomingTask.checked === true) {
      // Remove task from done tasks
      const nextDoneTasks = Array.from(doneTasks);
      const index = nextDoneTasks.findIndex((i) => i.id === incomingTask.id);
      const removedDoneTask = nextDoneTasks.splice(index, 1).shift();

      setDoneTasks(nextDoneTasks);
      saveDoneTasks(nextDoneTasks);

      // Add task to undone list
      const taskUnchecked = {
        ...removedDoneTask,
        checked: false,
      };
      const nextTasks = [...tasks, taskUnchecked];
      setTasks(nextTasks);
      saveTasks(nextTasks);
    }

    playRandomClick();
  }

  function playRandomClick() {
    const toPlay = sounds[Math.floor(Math.random() * sounds.length)];
    if (sound) {
      toPlay();
    }
  }

  function updateTask(incomingTask, newLabel) {
    if (newLabel.length === 0) {
      return;
    }

    const nextTask = {
      ...incomingTask,
      label: newLabel,
    };

    const nextTasks = tasks.map((task) => {
      if (task.id === incomingTask.id) {
        return nextTask;
      } else {
        return task;
      }
    });

    setTasks(nextTasks);
    saveTasks(nextTasks);
  }

  function deleteTask(incomingTask) {
    // Wenn Undone Task
    if (incomingTask.checked === false) {
      const nextTasks = tasks.filter((task) => task.id !== incomingTask.id);
      setTasks(nextTasks);
      saveTasks(nextTasks);
      saveTasks(nextTasks);
      checkIfConfetti(nextTasks);
    } else {
      const nextDoneTasks = doneTasks.filter(
        (task) => task.id !== incomingTask.id
      );
      setDoneTasks(nextDoneTasks);
      saveDoneTasks(nextDoneTasks);
    }
  }

  function saveTasks(items) {
    localStorage.setItem("undoneTasks", JSON.stringify(items));
  }

  function saveDoneTasks(items) {
    localStorage.setItem("doneTasks", JSON.stringify(items));
  }

  function loadAll() {
    let tasks = JSON.parse(localStorage.getItem("undoneTasks"));
    let doneTasks = JSON.parse(localStorage.getItem("doneTasks"));

    if (tasks !== null) {
      setTasks(tasks);
    } else {
      setTasks([
        {
          id: crypto.randomUUID(),
          label: "Clean windows",
          checked: false,
          date: Date.now(),
        },
        {
          id: crypto.randomUUID(),
          label: "Clean kitchen",
          checked: false,
          date: Date.now(),
        },
        {
          id: crypto.randomUUID(),
          label: "Take out trash",
          checked: false,
          date: Date.now(),
        },
      ]);
    }

    if (doneTasks !== null) {
      setDoneTasks(doneTasks);
    } else {
      setDoneTasks([]);
    }
  }

  function checkIfConfetti(nextTasks) {
    if (nextTasks.filter((task) => task.checked === false) <= 0) {
      if (sound) {
        allDoneSound();
      }
      const confetti = new JSConfetti();

      confetti.addConfetti({
        confettiRadius: 0,
        emojis: ["🍽️", "✅", "✅"],
        emojiSize: 40,
        confettiNumber: 30,
      });
    }
  }

  function handleOnDragEnd(result) {
    if (!result.destination) {
      return;
    }
    const items = Array.from(tasks);
    const [reorderedItems] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItems);

    console.log(items);
    setTasks(items);
    saveTasks(items);
  }

  return (
    <div className="flex-col space-y-9 transition-all delay-150 ease-in-out">
      <form onSubmit={handleAddTask}>
        <InputField input={task} setInput={setTask} />
      </form>

      <Flipper flipKey={JSON.stringify(tasks)}>
        {tasks.length === 0 ? (
          <Flipped flipId="Done">
            <span className="mt-10 mb-5 block rounded-xl bg-slate-50 p-8 text-center text-base opacity-100 dark:bg-zinc-700 dark:text-zinc-300">
              🎉 Nothing on your plate!
            </span>
          </Flipped>
        ) : undefined}

        <DragDropContext onDragEnd={handleOnDragEnd}>
          <Droppable droppableId="tasks">
            {(provided) => (
              <ol
                className="space-y-0"
                {...provided.droppableProps}
                ref={provided.innerRef}
              >
                {tasks.map((task, index) => (
                  <Flipped key={task.id} flipId={task.id}>
                    <Draggable draggableId={task.id} index={index}>
                      {(provided) => (
                        <Task
                          // key={task.id}
                          task={task}
                          checkTask={checkTask}
                          deleteTask={deleteTask}
                          updateTask={updateTask}
                          dndDragHandleProps={provided.dragHandleProps}
                          dndProps={provided.draggableProps}
                          ref={provided.innerRef}
                        />
                      )}
                    </Draggable>
                  </Flipped>
                ))}
                {provided.placeholder}
              </ol>
            )}
          </Droppable>
        </DragDropContext>

        {doneTasks.length > 0 ? (
          <Flipped flipId="archiveToggle">
            <div
              className="group/badge ml-3 mt-9 inline-flex cursor-pointer items-center gap-2 rounded-full bg-gray-100 px-3 py-1 text-gray-400 hover:bg-gray-200 hover:text-gray-500 dark:bg-zinc-700/50 dark:text-zinc-400/60 dark:hover:bg-zinc-700 dark:hover:text-zinc-400"
              onClick={() => {
                setArchiveIsVisible(!archiveIsVisible);
                playRandomClick();
              }}
            >
              <h3>Archive</h3>
              <span className="rounded-full bg-gray-200 px-2 py-0 text-sm group-hover/badge:bg-gray-300 dark:bg-zinc-500 dark:text-zinc-200 dark:group-hover/badge:bg-zinc-500">
                {doneTasks.length}
              </span>
              <BiChevronRight
                className={`${
                  archiveIsVisible ? "rotate-0" : "rotate-90"
                } scale-150 transition-all duration-300 ease-bouncy`}
              />
            </div>
          </Flipped>
        ) : undefined}

        {/* Archive */}
        <ol
          className={`mt-3 transition-all duration-75  ease-linear ${
            !archiveIsVisible ? "block" : "hidden"
          }`}
        >
          {doneTasks
            .sort((a, b) => b.checkedDate - a.checkedDate)
            .map((task) => (
              <Flipped key={task.id} flipId={task.id}>
                <Task
                  key={task.id}
                  task={task}
                  checkTask={checkTask}
                  deleteTask={deleteTask}
                  updateTask={updateTask}
                />
              </Flipped>
            ))}
        </ol>
      </Flipper>
    </div>
  );
}

export default TasksList;
